// extracted by mini-css-extract-plugin
var _1 = "PreviewEmbed-module__container--nyhZz";
export { _1 as "container" }
